import { render, staticRenderFns } from "./GlobalDailyResumeCredit.vue?vue&type=template&id=674223d6&"
import script from "./GlobalDailyResumeCredit.vue?vue&type=script&lang=js&"
export * from "./GlobalDailyResumeCredit.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDailyResumeCredit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports